export default __webpack_public_path__ + "static/media/upload.d9c9f311.svg";